import { faTemperatureEmpty, faTemperatureFull, faTemperatureHalf } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CircularProgress, useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import DefaultButton from '../../../components/Accessibility/DefaultButton';
import DefaultText from '../../../components/Accessibility/DefaultText';
import DefaultTextBold from '../../../components/Accessibility/DefaultTextBold';
import PageTitle from '../../../components/Accessibility/PageTitle';
import { Resultado } from '../../../interfaces/entities/SaudeBemEstar/AutoAvaliacao/Resultado';
import { getResultado as getResultadoAutoAvaliacao, getResultadoAvaliacao } from '../../../services/SaudeBemEstar/SaudeEmocionalService';
import './styles.css';

const AutoAvaliacaoResult: React.FC = () => {

  const navigate = useNavigate();
  const { idQuestOrResultType } = useParams();
  const mobileScreen = useMediaQuery('(max-width: 768px)');
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const mode = queryParams.get('mode');

  const [resultado, setResultado] = useState<Resultado | null>(null)
  const [loading, setLoading] = useState<boolean>(true);

  const cleanedSvg = resultado?.imagem.replace('data:image/svg;base64,', '') || '';
  const isInformativo: boolean = !idQuestOrResultType?.match(/^[0-9]+$/);

  useEffect(() => {
    if (idQuestOrResultType) {
      getResultado(idQuestOrResultType)
    }
  }, []);

  const getResultado = (idQuestOrResultType: string) => {
    setLoading(true);

    if (!idQuestOrResultType.match(/^[0-9]+$/)) {
      getResultadoAvaliacao(idQuestOrResultType)
        .then(setResultado)
        .catch(console.log)
        .finally(() => { setLoading(false) })
    }
    else {
      getResultadoAutoAvaliacao(idQuestOrResultType)
        .then(setResultado)
        .catch(console.log)
        .finally(() => { setLoading(false) })
    }
  }

  const deParaIcone = (resultado: string) => {
    switch (resultado) {
      case 'B':
        return { icon: faTemperatureEmpty, color: '#156D44' }
      case 'M':
        return { icon: faTemperatureHalf, color: '#F47920' }
      case 'A':
      default:
        return { icon: faTemperatureFull, color: '#D84141' }
    }
  }

  const shouldShowAgendarConsultaButton = () => {
    return ['A', 'M'].includes(resultado?.resultado || '') && mode !== 'visualizar' && !isInformativo;
  };

  return (
    <div className='page-container'>
      <PageTitle text="Resultado" />

      {
        loading ?
          <div className="width-100-pc flex-row justify-center">
            <CircularProgress />
          </div>
          :
          <>
            {resultado?.imagem &&
              <img
                src={`data:image/svg+xml;base64,${cleanedSvg}`} alt={`Imagem para resultado ${resultado?.titleIcon}`}
                className='autoavaliacao-result-image'
              />
            }
            <div className='flex-row gap-10'>
              <FontAwesomeIcon className='temperature-icon' icon={deParaIcone(resultado?.resultado || '').icon} color={deParaIcone(resultado?.resultado || '').color} />
              <DefaultTextBold text={resultado?.titleIcon || ''} />
            </div>

            <div className='max-width-660'>
              <DefaultText text={resultado?.texto || ''} />
            </div>

            <div className={`${mobileScreen ? 'flex-column width-100' : 'flex-row'} gap-20`}>
              {shouldShowAgendarConsultaButton() &&
                <DefaultButton
                  text='Agendar consulta'
                  onClick={() => { navigate('/saudeBemEstar/unimedAcolhe/agendamentos/agendar') }}
                  className='autoavaliacao-result-button'
                />
              }
              <DefaultButton
                variant={'contained'}
                text='Voltar para o início'
                onClick={() => { navigate('/saudeBemEstar/unimedAcolhe/autoAvaliacao') }}
                className='autoavaliacao-result-button'
              >
              </DefaultButton>
            </div>
          </>
      }


    </div>
  )
}

export default AutoAvaliacaoResult;